/* eslint-disable no-shadow */
import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

export class OPTInitialSetupServiceOrderApi implements IAPI {
  prefix = '/OPTInitialSetupServiceOrderManagement'

  fetchList (params: TOPTInitialSetupService.FetchList) {
    const url = appendParams(`${this.prefix}/GetPagedOrders`, params)
    return API.get<TOPTInitialSetupService.TState['optInitialSetupServiceOrderList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TOPTInitialSetupService.TState['initialSetupOrderDetail']>(`${this.prefix}/GetById?Id=${id}`)
  }

  saveChangeStatus (data: any) {
    return API.patch(`${this.prefix}/ChangeStatus`, data)
  }

  async downloadExcel (params: any) {
    const url = appendParams('OPTInitialSetupServiceOrderManagement/DownloadExcel', params)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }
}

export const optInitialSetupServiceOrderApi = new OPTInitialSetupServiceOrderApi()
